import moment from 'moment';
import { REVERSED_DATE_FORMAT_HYPHEN } from '../../../common/constants';
import { PickedMonthDate } from '../components/energyusage/types/ChartTypes';

export const getDateRange = (period: string, customDateRange?: PickedMonthDate): PickedMonthDate => {
  let startDate = '';
  let endDate = moment().format(REVERSED_DATE_FORMAT_HYPHEN);

  if (period === '6') {
    startDate = moment().subtract(5, 'months').startOf('month').format(REVERSED_DATE_FORMAT_HYPHEN);
  } else if (period === '12') {
    startDate = moment().subtract(11, 'months').startOf('month').format(REVERSED_DATE_FORMAT_HYPHEN);
  } else if (period === '24') {
    startDate = moment().subtract(23, 'months').startOf('month').format(REVERSED_DATE_FORMAT_HYPHEN);
  } else if (period === 'daily') {
    startDate = moment(customDateRange?.begin).format('YYYY-MM-DD') ?? '';
    endDate = moment(customDateRange?.end).format('YYYY-MM-DD') ?? '';
  } else if (period === 'halfhourly') {
    startDate = customDateRange?.begin ?? '';
    endDate = customDateRange?.end ?? '';
  } else {
    console.error(`Received unhandled range value: "${period}"`);
  }

  return {
    begin: startDate,
    end: endDate,
  };
};
